import React from "react";
import { StationsPageTemplate } from "themes/application/categories/pages";
import { StationsViewStore } from "application/categories/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView((rootStore, componentProps) => new StationsViewStore(rootStore, componentProps), "stationsViewStore")
class StationsPage extends React.Component {
    render() {
        return <StationsPageTemplate {...this.props} />;
    }
}

export default StationsPage;
